import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=38ff1244"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports